import { useAtomValue } from "jotai";

import { AirPlayButton } from "@/components/atoms/AirPlayButton";
import { ChromecastButton } from "@/components/atoms/ChromecastButton";
import { IconButton } from "@/components/atoms/IconButton";
import { Icon, StreamingIcons } from "@/components/atoms/Icon";
import { Text } from "@/components/atoms/Text";
import { useClassNames } from "@/utils/classNames";
import { selectedAssetAtom } from "@/constants/atoms";

import styles from "./VideoControlsTop.module.scss";
import { VideoControlsTopProps } from "./types";

/**
 * Top video player controls molecule that provides casting capabilities
 * Includes AirPlay (Safari), Chromecast buttons, and optional close button
 *
 * @param props - The video controls properties
 * @returns the video controls component
 */
const VideoControlsTop = ({ onClose, className }: VideoControlsTopProps) => {
  const cn = useClassNames(styles, styles["top-video-controls"], className);
  const selectedAsset = useAtomValue(selectedAssetAtom);

  return (
    <div className={cn}>
      <IconButton
        icon={StreamingIcons.Close}
        onClick={onClose}
        ariaLabel="Close video player"
        className={styles["control-icon"]}
      />

      <div className={styles["video-title-container"]}>
        <Text variant={"h2"} className={styles["video-title"]}>
          {selectedAsset?.attributes?.title}
        </Text>
        <Icon
          icon={StreamingIcons.InfoOutline}
          className={styles["control-icon"]}
        />
      </div>

      <div className={styles["right-controls"]}>
        <ChromecastButton className={styles["control-icon"]} />

        <AirPlayButton className={styles["control-icon"]} />
      </div>
    </div>
  );
};

export { VideoControlsTop };
